import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { LogoMark } from "../components/Logo";

const inputCls = "w-full bg-[#0d0e12] border border-[#232530] px-4 py-3 text-[#ede8e1] font-light placeholder:text-[#57534e] focus:border-[#581313] focus:outline-none transition-colors";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("sara.rezaeeH@outlook.com");
  const [password, setPassword] = useState("vault-keeper-2026");
  const [busy, setBusy] = useState(false);

  if (user) {
    navigate("/admin", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate("/admin", { replace: true, state: { user: data } });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#070709] flex items-center justify-center px-4 relative" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md relative z-10">
        <div className="flex flex-col items-center mb-10">
          <LogoMark size={48} />
          <h1 className="mt-6 font-display text-xl tracking-[0.2em] uppercase text-[#ede8e1]">The Sanctum</h1>
          <p className="mt-2 font-mono text-[11px] tracking-[0.3em] uppercase text-[#78716c]">Keepers only beyond this door</p>
        </div>
        <form onSubmit={submit} className="border border-[#232530] bg-[#0d0e12] p-8 space-y-5" data-testid="admin-login-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email" className={inputCls} data-testid="admin-login-email-input" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password" className={inputCls} data-testid="admin-login-password-input" />
          <button type="submit" disabled={busy} data-testid="admin-login-submit-button"
            className="w-full bg-[#581313] hover:bg-[#581313] disabled:opacity-50 text-[#ede8e1] border border-[#581313]/40 font-mono text-xs uppercase tracking-widest px-6 py-3 transition-colors">
            {busy ? "Unsealing…" : "Enter the Sanctum"}
          </button>
          <div className="flex items-center gap-4">
            <span className="flex-1 border-t border-[#232530]" />
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#57534e]">or</span>
            <span className="flex-1 border-t border-[#232530]" />
          </div>
          <button type="button" onClick={googleLogin} data-testid="admin-google-login-button"
            className="w-full bg-[#14151b] hover:bg-[#232530] text-[#ede8e1] border border-white/10 font-mono text-xs uppercase tracking-widest px-6 py-3 transition-colors">
            Enter with Google
          </button>
        </form>
        <p className="mt-6 text-center">
          <Link to="/" className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#78716c] hover:text-[#581313] transition-colors">
            Return to the Vault
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
